const PIXEL_ID = '1206725874775777'

let initialized = false

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

/**
 * Injects the official Meta (Facebook) Pixel base code into the page.
 * This is the exact snippet Meta provides, adapted for a React SPA.
 */
function loadPixelScript(): void {
  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */
}

/**
 * Initializes the Meta Pixel and fires the initial PageView.
 * Safe to call multiple times — only runs once, and only in the browser.
 */
export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return
  loadPixelScript()
  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
  initialized = true
}

/**
 * Tracks a standard or custom Meta Pixel event.
 * No-ops silently if the pixel hasn't loaded yet (e.g. SSR / blocked).
 */
export function trackPixel(
  event: string,
  data?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, data)
}
